"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SankeyDevClickSaveDiagram = exports.SankeyDevInputDialogSaveJSON = void 0;
/* eslint @typescript-eslint/no-var-requires: "off" */
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const file_saver_1 = __importDefault(require("file-saver"));
const react_2 = require("@chakra-ui/react");
const SankeyUtils_1 = require("open-sankey/dist/configmenus/SankeyUtils");
const SankeyDevInputDialogSaveJSON = (t, to_beautify, set_to_beautify) => {
    return react_1.default.createElement(react_bootstrap_1.Form.Group, null,
        react_1.default.createElement(react_2.Checkbox, { sx: (0, SankeyUtils_1.SmoothClasses)({}), maxW: '40%', isChecked: to_beautify, onChange: () => set_to_beautify(!to_beautify) },
            t('Menu.toBeautify'),
            " ",
            react_1.default.createElement(react_bootstrap_1.Badge, { pill: true, bg: "info", style: { marginLeft: 'auto' } }, "Dev")));
};
exports.SankeyDevInputDialogSaveJSON = SankeyDevInputDialogSaveJSON;
const SankeyDevClickSaveDiagram = (data, name = 'sankey_diagram') => {
    const data_to_save = Object.assign({}, data);
    const str_data = JSON.stringify(data_to_save, null, 2);
    const blob = new Blob([str_data], { type: 'text/plain;charset=utf-8' });
    if (data.view.length > 0 && !data.is_catalog) {
        name = 'Diagramme de Sankey avec vues';
    }
    else if (data.is_catalog) {
        name = 'Catalogue de vues de diagrammes de Sankey';
    }
    else {
        name = 'Diagramme de Sankey';
    }
    file_saver_1.default.saveAs(blob, name + '.json');
};
exports.SankeyDevClickSaveDiagram = SankeyDevClickSaveDiagram;
